export default __webpack_public_path__ + "static/media/icon-info.2bcba3b0.svg";